export const GET_VORGAENGE = 'vorgaenge.getVorgaenge';
export const SET_VORGAENGE = 'vorgaenge.setVorgaenge';

export const SET_VORGANG_RELASEPROCESS_BY_ID = 'vorgaenge.setVorgangReleaseprocessById';

export const GET_VORGAENGE_WITH_FLIGHTS_TEILNEHMER = 'vorgaenge.getVorgaengeWithFlightsTeilnehmer';

export const GET_VORGAENGE_FILTER = 'vorgaenge.getVorgaengeFilter';
export const SET_VORGAENGE_FILTER = 'vorgaenge.setVorgaengeFilter';

export const GET_VORGAENGE_EXPAND = 'vorgaenge.getVorgaengeExpand';
export const SET_VORGAENGE_EXPAND = 'vorgaenge.setVorgaengeExpand';

export const SET_VORGAENGE_COUNT = 'vorgaenge.setVorgaengeCount';
export const SET_VORGAENGE_TOP = 'vorgaenge.setVorgaengeTop';
export const SET_VORGAENGE_SKIP = 'vorgaenge.setVorgaengeSkip';
export const SET_VORGAENGE_ORDER_BY = 'vorgaenge.setVorgaengeOrderBy';

export const VORGAENGE_SORT_CHANGED = 'vorgaenge.sortChanged';
export const VORGAENGE_PAGE_CHANGED = 'vorgaenge.pageChanged';

export const SET_IS_LOADING = 'vorgaenge.setIsLoading';
export const SET_IS_INITIAL_LOADING = 'vorgaenge.setIsInitialLoading';

export const SAVE_VORANG_RELEASEPROCESS_STEP1 = 'vorgaenge.saveVorgangReleaseprocessStep1';
export const SAVE_VORANG_RELEASEPROCESS_STEP1_ARRAY = 'vorgaenge.saveVorgangReleaseprocessStep1Array';
export const SAVE_TRANSFERPLANUNG_PROCESS = 'vorgaenge.saveTransferplanungProcess';
export const RESET_TRANSFERPLANUNG_FLUEGE = 'vorgaenge.resetTransferplanungFluege';

export const GET_TH_WERTE_AT_BUCHUNGSDATUM_BY_VORGANG_ID = 'vorgaenge.getThWerteAtBuchungsdatumByVorgangId';
export const SET_TH_WERTE_AT_BUCHUNGSDATUM_BY_VORGANG_ID = 'vorgaenge.setThWerteAtBuchungsdatumByVorgangId';

export const CHANGE_RELEASEPROCESS_ATTRIBUTES = 'vorgaenge.changeReleaseprocessAttributes';
export const UPDATE_VORGANG_RELEASEPROZESS = 'vorgaenge.updateVorgangReleaseprozess';
export const REFRESH_VORGANG_RELEASEPROZESSE = 'vorgaenge.refreshVorgangReleaseprozesse';

import apiService from '@/core/common/services/api.service';
import {
  sortFluegeByAbflugdatumAndAbflugzeit,
  getDifferentFlights,
  parseEigenanreiseText,
} from '@/core/common/helpers/utils';

import * as odataService from '@/core/common/services/odata.service';
import { convertTableSortToOdata } from '@/core/common/helpers/odataUtils';
import { getReleaseprozessStatus } from '@/core/produkte/reisetermine/stores/reisetermine.module';

const state = () => ({
  vorgaenge: [],
  thwerteAtBuchungsdatumByVorgangId: null,
  isLoading: false,
  isInitialLoading: true,
  filter: null,
  top: 100,
  skip: 0,
  orderBy: null,
  count: 0,
  expand: {
    agentur: {},
    teilnehmers: {
      filter: {
        deletedAt: null,
      },
      expand: {
        optionalsOhneKontingent: {},
        optionalsMitKontingent: {},
        verlaengerungen: {},
        teilnehmerVerlaengerungen: {},
        dokumente: {},
      },
    },
    hotelleistungen: {
      filter: {
        isDeleted: false,
      },
      expand: {
        Reisetermin: {
          filter: {
            isDeleted: false,
          },
          expand: {
            gueltigeKonfiguration: {},
            Reise: { expand: { konfigurationen: {} } },
            pax: {},
          },
        },
      },
    },
    kunde: {
      expand: {
        master: {
          expand: {
            kunden: {},
          },
        },
      },
    },
  },
});

const getters = {};

// Hält die laufende Anfrage aus GET_VORGAENGE_WITH_FLIGHTS_TEILNEHMER,
// damit parallele Aufrufe für denselben Reisetermin nicht doppelt laden
let laufenderVorgaengeRequest = null;

const actions = {
  [CHANGE_RELEASEPROCESS_ATTRIBUTES](context, attributes) {},
  [GET_VORGAENGE](context, filter) {
    if (filter) {
      context.commit(SET_VORGAENGE_FILTER, filter);
    }
    context.commit(SET_IS_LOADING, true);
    return odataService
      .getVorgang({
        filter: context.state.filter,
        expand: context.state.expand,
        top: context.state.top,
        skip: context.state.skip,
        count: true,
      })
      .then(response => {
        context.commit(SET_VORGAENGE_COUNT, response.count || 0);
        context.commit(SET_VORGAENGE, response.data);
        return response.data;
      })
      .finally(() => {
        context.commit(SET_IS_LOADING, false);
        context.commit(SET_IS_INITIAL_LOADING, false);
      });
  },
  [GET_VORGAENGE_WITH_FLIGHTS_TEILNEHMER](context, { reiseterminId: reiseterminId, filter: filter }) {
    // Mehrere Komponenten der Reiseterminseite laden dieselben Vorgänge im selben Tick,
    // deshalb werden Anfragen für parallele Aufrufe für denselben Reisetermin geteilt
    if (laufenderVorgaengeRequest && laufenderVorgaengeRequest.reiseterminId === reiseterminId) {
      return laufenderVorgaengeRequest.promise;
    }

    context.commit(SET_VORGAENGE_FILTER, {
      and: [
        filter && filter,
        {
          hotelleistungen: {
            any: {
              isDeleted: false,
              reiseterminId: parseInt(reiseterminId),
            },
          },
        },
      ],
    });
    context.commit(SET_IS_LOADING, true);

    const vorgaengePromise = odataService.getVorgang({
      filter: context.state.filter,
      expand: context.state.expand,
      top: context.state.top,
      skip: context.state.skip,
      count: true,
    });
    const releaseprozessePromise = getVorgangReleaseprozesse(reiseterminId);

    const promise = Promise.all([vorgaengePromise, releaseprozessePromise])
      .then(async ([vorgaengeResponse, releaseprozesse]) => {
        const vorgaengeWithFlightsTeilnehmer = getTeilnehmerAndFluege(vorgaengeResponse.data);

        // Releaseprozessdaten mit Vorgängen zusammenführen
        const vorgaengeMitReleaseprozess = mergeReleaseprozesseIntoVorgaenge(
          vorgaengeWithFlightsTeilnehmer,
          releaseprozesse
        );

        context.commit(SET_VORGAENGE_COUNT, vorgaengeResponse.count || 0);
        context.commit(SET_VORGAENGE, vorgaengeMitReleaseprozess);
        return vorgaengeMitReleaseprozess;
      })
      .finally(() => {
        laufenderVorgaengeRequest = null;
        context.commit(SET_IS_LOADING, false);
        context.commit(SET_IS_INITIAL_LOADING, false);
      });

    laufenderVorgaengeRequest = { reiseterminId, promise };
    return promise;
  },
  [UPDATE_VORGANG_RELEASEPROZESS]({ state, commit }, params) {
    return apiService.put('/Vorgang/releaseprozess', params).then(res => {
      const { result } = res.data;
      // result ist ein Array, umwandeln in Objekt mit vorgangId als Key
      const resultByVorgangId = Array.isArray(result)
        ? result.reduce((acc, item) => ({ ...acc, [item.vorgangId]: item }), {})
        : result;
      const updatedVorgaenge = state.vorgaenge.map(v => {
        const item = resultByVorgangId[v.id];
        if (item) {
          return {
            ...v,
            isReleased: item.isReleased,
            releaseprozessTeilnehmerErledigt: item.releaseprozessTeilnehmerErledigt,
            releaseprozessReiseleistungListenversandErledigt:
              item.releaseprozessReiseleistungListenversandErledigt,
            gebuchteReiseleistungListenversandGeprueft: item.gebuchteReiseleistungListenversandGeprueft,
            // Beide Prüf-Felder speisen den Zustand der Checkbox
            passdatenGeprueft: item.passdatenGeprueft,
            dokumenteGeprueft: item.dokumenteGeprueft,
            // Store Update für die 4 Icons der Progess bar
            teilnehmerdatenStatus: item.teilnehmerdatenStatus,
            reiseleistungListenversandStatus: item.reiseleistungListenversandStatus,
            fluegeStatus: item.fluegeStatus,
            transferplanungStatus: item.transferplanungStatus,
          };
        }
        return v;
      });
      commit(SET_VORGAENGE, updatedVorgaenge);
    });
  },
  [REFRESH_VORGANG_RELEASEPROZESSE]({ state, commit }, { reiseterminId }) {
    return getVorgangReleaseprozesse(reiseterminId).then(releaseprozesse => {
      commit(SET_VORGAENGE, mergeReleaseprozesseIntoVorgaenge(state.vorgaenge, releaseprozesse));
    });
  },
  [VORGAENGE_SORT_CHANGED](context, { sortContext: sortContext }) {
    const orderBy = convertTableSortToOdata(sortContext.sortBy, sortContext.sortDesc);
    context.commit(SET_VORGAENGE_ORDER_BY, orderBy);
    context.commit(SET_VORGAENGE_SKIP, 0);
    return context.dispatch(GET_VORGAENGE);
  },
  [VORGAENGE_PAGE_CHANGED](context, { pageContext: pageContext }) {
    context.commit(SET_VORGAENGE_SKIP, pageContext.skip);
    context.commit(SET_VORGAENGE_TOP, pageContext.top);
    return context.dispatch(GET_VORGAENGE);
  },
  [SAVE_VORANG_RELEASEPROCESS_STEP1](context, { id: id, releaseProcessObject: releaseProcessObject }) {
    context.commit(SET_IS_LOADING, true);
    return saveReleaseprozessProcess(id, releaseProcessObject)
      .then(response => {
        context.commit(SET_VORGANG_RELASEPROCESS_BY_ID, {
          id: id,
          releaseprocess: {
            gebuchteReiseleistungListenversandGeprueft:
              response[id].gebuchteReiseleistungListenversandGeprueft,
          },
          isReleased: response[id].isReleased,
        });
      })
      .finally(() => {
        context.commit(SET_IS_LOADING, false);
        context.commit(SET_IS_INITIAL_LOADING, false);
      });
  },
  [SAVE_VORANG_RELEASEPROCESS_STEP1_ARRAY](
    context,
    { releaseProcessObjectsArray: releaseProcessObjectsArray, reiseterminId: reiseterminId }
  ) {
    context.commit(SET_IS_LOADING, true);
    const mappedValuesReleaseProcessArray = mapReleaseProcessValues(releaseProcessObjectsArray);
    return saveReleaseprozessProcessArray(mappedValuesReleaseProcessArray).finally(() => {
      context.commit(SET_IS_LOADING, false);
      context.commit(SET_IS_INITIAL_LOADING, false);
      return context.dispatch(GET_VORGAENGE_WITH_FLIGHTS_TEILNEHMER, { reiseterminId: reiseterminId });
    });
  },
  [SAVE_TRANSFERPLANUNG_PROCESS](context, { id: id, transferplanungObject: transferplanungObject }) {
    context.commit(SET_IS_LOADING, true);
    transferplanungObject.id = id;
    return saveTransferplanungProcess(id, transferplanungObject).finally(() => {
      context.commit(SET_IS_LOADING, false);
      context.commit(SET_IS_INITIAL_LOADING, false);
    });
  },
  [RESET_TRANSFERPLANUNG_FLUEGE](context, { id: id }) {
    context.commit(SET_IS_LOADING, true);
    return resetTransferplanungFluege(id).finally(() => {
      context.commit(SET_IS_LOADING, false);
      context.commit(SET_IS_INITIAL_LOADING, false);
    });
  },
  [GET_TH_WERTE_AT_BUCHUNGSDATUM_BY_VORGANG_ID](
    context,
    { reiseterminId: reiseterminId, vorgaenge: vorgaenge }
  ) {
    const thwerteAtBuchungsdatumObject = vorgaenge.reduce((acc, cur) => {
      acc[cur.id] = {
        isLoading: true,
        thWert: null,
        basisPreis: null,
      };
      return acc;
    }, {});
    context.commit(SET_TH_WERTE_AT_BUCHUNGSDATUM_BY_VORGANG_ID, thwerteAtBuchungsdatumObject);

    vorgaenge.map(vorgang => {
      return getThWerteAtBuchungsdatum(reiseterminId, vorgang.buchungsdatum, vorgang.id).then(
        ({ data, vorgangId }) => {
          thwerteAtBuchungsdatumObject[vorgangId] = { data, isLoading: false };
          context.commit(SET_TH_WERTE_AT_BUCHUNGSDATUM_BY_VORGANG_ID, thwerteAtBuchungsdatumObject);
        }
      );
    });
    return thwerteAtBuchungsdatumObject;
  },
};

const mutations = {
  [SET_VORGANG_RELASEPROCESS_BY_ID](state, { id, releaseprocess, isReleased }) {
    const vorgang = state.vorgaenge.find(vorgang => vorgang.id === id);
    vorgang.vorgangReleaseprozessStep1 = releaseprocess;
    vorgang.isReleased = isReleased;
  },
  [SET_TH_WERTE_AT_BUCHUNGSDATUM_BY_VORGANG_ID](state, thwerteAtBuchungsdatumByVorgangId) {
    state.thwerteAtBuchungsdatumByVorgangId = thwerteAtBuchungsdatumByVorgangId;
  },
  [SET_VORGAENGE_EXPAND](state, expand) {
    state.filter = expand;
  },
  [SET_VORGAENGE_FILTER](state, filter) {
    state.filter = filter;
  },
  [SET_VORGAENGE](state, vorgaenge) {
    state.vorgaenge = vorgaenge;
  },
  [SET_IS_LOADING](state, isLoading) {
    state.isLoading = isLoading;
  },
  [SET_IS_INITIAL_LOADING](state, isInitialLoading) {
    state.isInitialLoading = isInitialLoading;
  },
  [SET_VORGAENGE_COUNT](state, count) {
    state.count = count;
  },
  [SET_VORGAENGE_ORDER_BY](state, orderBy) {
    state.orderBy = orderBy;
  },
  [SET_VORGAENGE_SKIP](state, skip) {
    state.skip = skip;
  },
  [SET_VORGAENGE_TOP](state, top) {
    state.top = top;
  },
};

function getTeilnehmerAndFluege(vorgaenge) {
  let tmpVorgaenge = [...vorgaenge];
  return tmpVorgaenge.map(vorgang => {
    vorgang._showDetails = true;

    vorgang.teilnehmer = vorgang.teilnehmers;

    // Flüge und Vergleichsstand hängen als JSON-Attribute am Teilnehmer
    // Das Z aus OData wird entfernt, da die Flugzeiten lokale Flughafenzeiten sind
    vorgang.teilnehmer.forEach(teilnehmer => {
      teilnehmer.fluege = sortFluegeByAbflugdatumAndAbflugzeit(
        (teilnehmer.fluege || [])
          .filter(flug => !flug.deletedAt)
          .map(flug => ({
            ...flug,
            abflugdatum: flug.abflugdatum?.replace(/Z$/, ''),
            ankunftsdatum: flug.ankunftsdatum?.replace(/Z$/, ''),
          }))
      );
    });

    const fluegeAfterBuchungReleased = vorgang.teilnehmer.flatMap(teilnehmer =>
      (teilnehmer.fluegeAfterBuchungReleased || [])
        .filter(flug => !flug.deletedAt)
        .map(flug => ({
          ...flug,
          abflugdatum: flug.abflugdatum?.replace(/Z$/, ''),
          ankunftsdatum: flug.ankunftsdatum?.replace(/Z$/, ''),
        }))
    );

    // Vorgangsweite Flugliste aus den Teilnehmerflügen, Objektreferenzen bleiben erhalten
    vorgang.fluege = sortFluegeByAbflugdatumAndAbflugzeit(
      vorgang.teilnehmer.flatMap(teilnehmer => teilnehmer.fluege)
    );

    // Matchteilnehmer flugIds and flug flugId
    vorgang.fluege.map(flug => {
      // Map the participants of the current vorgang
      vorgang.teilnehmer.map((teilnehmer, teilnehmerIndex) => {
        // If the participant has flight ids and it is an array and the array is not empty
        if (teilnehmer.flugIds && Array.isArray(teilnehmer.flugIds) && teilnehmer.flugIds.length > 0) {
          // If the flight id of the current flight is included in the flight ids of the current participant
          if (teilnehmer.flugIds.includes(flug.flugId)) {
            // Set the match number of the participant to the current index plus one
            teilnehmer.teilnehmerFluegeMatchNumber = teilnehmerIndex + 1;
            // If the current flight has a match numbers array
            if (Array.isArray(flug.teilnehmerFluegeMatchNumbers)) {
              // Add the current index plus one to the match numbers array of the current flight
              flug.teilnehmerFluegeMatchNumbers.push(teilnehmerIndex + 1);
            } else {
              // Create a match numbers array for the current flight and add the current index plus one to it
              flug.teilnehmerFluegeMatchNumbers = [];
              flug.teilnehmerFluegeMatchNumbers.push(teilnehmerIndex + 1);
            }
          }
        }
      });
    });

    // get an array of differences between old and new flights
    const differentFlights = getDifferentFlights(vorgang.fluege, fluegeAfterBuchungReleased);

    // if atleast one flight is different show it in vorgang table
    vorgang.isFlightsEqual =
      fluegeAfterBuchungReleased.length === 0 || (differentFlights && differentFlights.length === 0);
    vorgang.allFlights = {
      fluegeAfterBuchungReleased: fluegeAfterBuchungReleased,
      fluege: vorgang.fluege,
    };
    const parsedEigenanreise = vorgang.eigenanreiseText ? parseEigenanreiseText(vorgang) : null;
    const fluegeLength = vorgang.fluege.length;
    if (parsedEigenanreise && fluegeLength > 1) {
      if (!parsedEigenanreise.Ankunft) vorgang.failedParse = true;
      // Object.assign statt Kopie, damit die Anpassung auch in teilnehmer.fluege ankommt
      Object.assign(vorgang.fluege[0], {
        flugnummer: parsedEigenanreise.Ankunft ? parsedEigenanreise.Ankunft.flugnummer : null,
        ankunftsflughafenEigen: parsedEigenanreise.Ankunft ? parsedEigenanreise.Ankunft.flughafen : null,
        ankunftsZeit: parsedEigenanreise.Ankunft ? parsedEigenanreise.Ankunft.zeit : null,
      });
      Object.assign(vorgang.fluege[fluegeLength - 1], {
        flugnummer: parsedEigenanreise.Abflug ? parsedEigenanreise.Abflug.flugnummer : null,
        abflughafenEigen: parsedEigenanreise.Abflug ? parsedEigenanreise.Abflug.flughafen : null,
        abflugsZeit: parsedEigenanreise.Abflug ? parsedEigenanreise.Abflug.zeit : null,
      });
    }

    return vorgang;
  });
}

async function getThWerteAtBuchungsdatum(reiseterminId, buchungsdatum, vorgangId) {
  return apiService
    .get(`Reisetermin/${reiseterminId}/historical-prices/${buchungsdatum}`)
    .then(({ data }) => {
      return { data: data?.result?.value || '-', vorgangId: vorgangId };
    });
}

async function saveReleaseprozessProcess(id, releaseProcessObject) {
  return saveReleaseprozessProcessArray([{ ...releaseProcessObject, id }]).then(response => {
    return response;
  });
}

async function saveReleaseprozessProcessArray(releaseProcessObjectsArray) {
  const mappedValuesReleaseProcessArray = mapReleaseProcessValues(releaseProcessObjectsArray);
  return apiService.put('Vorgang/releaseprozesse/', mappedValuesReleaseProcessArray).then(response => {
    return response.data.result;
  });
}

async function saveTransferplanungProcess(id, transferplanungObject) {
  return apiService.put('Vorgang/releaseprozesse', transferplanungObject);
}

async function resetTransferplanungFluege(id) {
  return apiService.put(`Vorgang/${id}/workflow/transferplanung/fluege/reset`, { id });
}

function mapReleaseProcessValues(releaseProcessArray) {
  return releaseProcessArray.map(releaseProcessObject => {
    return Object.entries(releaseProcessObject).reduce((acc, key) => {
      acc[key[0]] =
        key[1] === 'NichtGeprueft'
          ? 1
          : key[1] === 'InArbeit'
          ? 2
          : key[1] === 'GeprueftVorhandenKorrekt'
          ? 3
          : key[1] === 'GeprueftNichtNotwendig'
          ? 4
          : key[1] === 'GeprueftNichtKorrektInArbeit'
          ? 5
          : key[1];
      return acc;
    }, {});
  });
}

// Aus dem Releaseprozess-Status des Reisetermins wird nur die Vorgangsebene benötigt
async function getVorgangReleaseprozesse(reiseterminId) {
  return getReleaseprozessStatus(reiseterminId).then(result => result?.vorgaenge || []);
}

// Mischt die vom Backend berechneten Releaseprozess-Stati in die vorhandenen Vorgänge
// Der Teilnehmerdaten-Status wird vom Core aus Passdaten und Dokumenten berechnet
function mergeReleaseprozesseIntoVorgaenge(vorgaenge, releaseprozesse) {
  const releaseprozesseByVorgangId = releaseprozesse.reduce((acc, releaseprozess) => {
    acc[releaseprozess.vorgangId] = releaseprozess;
    return acc;
  }, {});
  return vorgaenge.map(vorgang => {
    const releaseprozess = releaseprozesseByVorgangId[vorgang.id];
    if (!releaseprozess) return vorgang;
    return {
      ...vorgang,
      isReleased: releaseprozess.isReleased,
      gebuchteReiseleistungListenversandGeprueft: releaseprozess.gebuchteReiseleistungListenversandGeprueft,
      // Beide Prüf-Felder speisen den Zustand der Checkbox
      passdatenGeprueft: releaseprozess.passdatenGeprueft,
      dokumenteGeprueft: releaseprozess.dokumenteGeprueft,
      teilnehmerdatenStatus: releaseprozess.teilnehmerdatenStatus,
      reiseleistungListenversandStatus: releaseprozess.reiseleistungListenversandStatus,
      fluegeStatus: releaseprozess.fluegeStatus,
      transferplanungStatus: releaseprozess.transferplanungStatus,
    };
  });
}

export default {
  state,
  actions,
  mutations,
  getters,
};
